import React from 'react';
import styled from 'styled-components';
import { FoundationContextProvider } from '@clds/design-system-foundations';
import { LeftWrapper, RightWrapper, Root } from './Chip.styled.js';
import { useFoundation, useSurface } from './foundationMapping.js';
/** The purpose of this component is to display text within a small chip / pill. May be wrapped with `ChipList` */
export const Chip = styled(({ isHoverable = false, isSelected = false, tone, variant, size, label, leftSlot, rightSlot, rootProps, ...rest }) => {
    const foundation = useFoundation({ size });
    const surface = useSurface({ variant, tone });
    return (React.createElement(Root, { as: isHoverable ? 'button' : 'div', isHoverable: isHoverable, isSelected: isSelected, ...surface.componentProps, ...foundation.componentProps, ...rootProps, ...rest, "aria-selected": isSelected, "data-test": "chip" },
        React.createElement(FoundationContextProvider, { ...foundation.innerContextProps },
            leftSlot && React.createElement(LeftWrapper, null, leftSlot),
            label,
            rightSlot && React.createElement(RightWrapper, null, rightSlot))));
}) ``;
//# sourceMappingURL=Chip.js.map